import { Avatar, Box, HStack, Stack, StackProps, Text } from "@chakra-ui/react";
import { usePremiumRoutes } from "@ui/utils";
import { signOut } from "next-auth/react";
import { ReactNode } from "react";
import { FaSignOutAlt } from "react-icons/fa";
import { MdSupport } from "react-icons/md";
import { PremiumMenuProps } from "./menu";

export const PremiumMobileListItem = ({
  children,
  icon,
  ...props
}: StackProps & {
  icon: ReactNode;
}) => (
  <HStack
    rounded="md"
    cursor="pointer"
    p="2"
    _hover={{
      bg: "gray.100",
    }}
    {...props}
  >
    {icon}
    <Text>{children}</Text>
  </HStack>
);
export const PremiumMobileMenuList = (props: PremiumMenuProps) => {
  const { router, user } = usePremiumRoutes();
  return (
    <Stack>
      <Stack pb="4" alignItems="center" spacing="1" textAlign="center">
        <Avatar
          boxSize="8"
          name={props?.name || user?.name}
          src={props?.image || user?.image}
        />
        <Stack spacing="1">
          <Text fontSize="sm">{props?.name || user?.name}</Text>
          <Text fontSize="xs" color="subtle">
            {user?.email}
          </Text>
        </Stack>
      </Stack>
      {props.routes.map((route) => (
        <PremiumMobileListItem
          key={route.href}
          icon={<Box as={route.icon} />}
          rounded="md"
          onClick={() => router.push(route.href)}
        >
          {route.label}
        </PremiumMobileListItem>
      ))}
      <PremiumMobileListItem
        onClick={() => signOut({ callbackUrl: "signOut" })}
        icon={<FaSignOutAlt />}
      >
        Log Out
      </PremiumMobileListItem>
      <PremiumMobileListItem
        onClick={() => router.push("/support")}
        icon={<MdSupport />}
      >
        Support
      </PremiumMobileListItem>
    </Stack>
  );
};
